module.exports = __webpack_public_path__ + "img/english.24e60e6f.svg";